<template>
  <div class="pm-25-chart" v-if="data && data[active]">
    <h3 class="title">1-hr PM2.5 in the past 24 hr</h3>
    <responsive-svg v-slot="sizing" padding="0 2% 20 1%">
      <bar-chart v-bind="sizing"
        :data="data[active]"
        x="label"
        y="value"
        c="class"
        :y-domain="yDomain"
        :padding="0.25"
        :x-format="xFormat"
        :onRender="selectLatest()">
      </bar-chart>
    </responsive-svg>
    <tooltip v-if="latestRef" :target="latestRef.value" anchor="top">{{latest.value}}</tooltip>
  </div>
</template>

<script>
import ResponsiveSvg from 'vue-graphics/hocs/ResponsiveSvg'
import BarChart from './BarChart'
import Tooltip from './Tooltip'

export default {
  components: {
    ResponsiveSvg,
    BarChart,
    Tooltip
  },
  props: ['data', 'active'],
  data () {
    return {
      latestRef: null
    }
  },
  computed: {
    latest () {
      const data = this.data[this.active]
      return data[data.length - 1]
    },
    yDomain () {
      let highest = 0
      Object.values(this.data).forEach(data => {
        data.forEach(row => {
          if (row.value > highest) highest = row.value
        })
      })
      return [0, highest * 5 / 3]
    }
  },
  methods: {
    xFormat (label, i) {
      if (i === 0) return this.latest.label
      if ([6, 12, 18, 24].includes(i)) return label[0]
      return null
    },
    selectLatest () {
      this.$nextTick(() => {
        this.latestRef = Object.freeze({value: this.$el.querySelector('.vg-bar.latest')})
      })
    }
  }
}
</script>

<style lang="scss">
.pm-25-chart {
  position: relative;

  .title {
    font-size: 15px;
    line-height: 30px;
    margin: 0;
  }

  svg {
    display: block;
    width: 100%;
    height: 120px;
    box-sizing: border-box;
    margin-top: -40px;
  }

  .vg-tick {
    text {
      font-size: 13px;
      color: $black;
      opacity: 0.5;
    }

    &:first-child {
      text {
        text-anchor: start;
      }
    }

    &:last-child {
      text {
        text-anchor: end;
      }
    }
  }

  .band-1 {
    fill: rgba(#152B59, 0.25);
  }

  .band-2 {
    fill: #8D95A9;
  }

  .band-3 {
    fill: #8D95A9;
  }

  .band-4 {
    fill: #8D95A9;
  }

  .tooltip {
    font-family: $font-CuratorBold;
    font-size: 13px;
    line-height: initial;
    transform: translate(-50%, -100%);
    background: rgba($black, 0.8);
    border-radius: 4px;
    color: #ffffff;
    padding: 2px 5px;
    box-sizing: border-box;
    margin-top: -4px;
  }
}
</style>
